import { ProfileDto } from "@/shared/dtos/profile-dto";
import { ItiHttpService } from "../../iti-core-react/services/iti-http-service";
import { API } from "../api";
import { InvitationUserDto } from "../dtos/invitation-user-dto";
import { UserProfileDto } from "../dtos/user-profile-dto";

export const UserService = {
	async getUsers(): Promise<UserProfileDto[]> {
		const res = await ItiHttpService.get(`${API.centralizedAuth.users}`);
		return res.map((item: UserProfileDto) => new UserProfileDto(item));
	},
	async getUser(userId: string): Promise<UserProfileDto> {
		return await ItiHttpService.get(`${API.centralizedAuth.users}/${userId}`);
	},
	async create(user: UserProfileDto): Promise<UserProfileDto> {
		return await ItiHttpService.post(
			`${API.centralizedAuth.users}`,
			user.toJson(),
		);
	},
	async update(user: UserProfileDto): Promise<UserProfileDto> {
		return await ItiHttpService.put(
			`${API.centralizedAuth.users}/${user.userId}`,
			user.toJson(),
		);
	},
	async updatePassword(newPassword: string): Promise<UserProfileDto> {
		return await ItiHttpService.put(
			`${API.centralizedAuth.usersCurrent.password}`,
			newPassword,
		);
	},
	async delete(id: string): Promise<boolean> {
		return await ItiHttpService.delete(`${API.centralizedAuth.users}/${id}`);
	},
	async getProfiles(): Promise<ProfileDto[]> {
		const res = await ItiHttpService.get(
			API.centralizedAuth.usersCurrent.profiles,
		);
		return res.map((item: ProfileDto) => new ProfileDto(item));
	},
	async updateProfile(profile: ProfileDto): Promise<boolean> {
		try {
			await ItiHttpService.put(
				API.centralizedAuth.usersCurrent.profiles,
				profile,
			);
			return true;
		} catch (err) {
			return false;
		}
	},
	async createByInvitation(invitationUser: InvitationUserDto): Promise<string> {
		return await ItiHttpService.postWithoutAuth(
			`${API.centralizedAuth.users}`,
			invitationUser.toJson(["confirmPassword"]),
			true,
			false,
			true,
		);
	},
	async getCurrentUser(): Promise<ProfileDto> {
		const res = await ItiHttpService.get(
			`${API.centralizedAuth.usersCurrent.user}`,
		);
		return new ProfileDto(res);
	},
	async validateCurrentUser(): Promise<boolean> {
		const res = await ItiHttpService.get(
			`${API.centralizedAuth.usersCurrent.user}/isValid`,
		);
		return res;
	},
	async restorePassword(email: string): Promise<boolean> {
		const res = await ItiHttpService.post(
			`${API.centralizedAuth.passwordRestore}`,
			{ email: email },
		);
		return res;
	},
};
